<!-- <div class="modal-overlay" (click)="closeModal()"></div> -->
<div class="modal-container" role="dialog" aria-modal="true" aria-labelledby="modalTitle">
  <button class="close-btn" (click)="closeModal()" aria-label="Close modal">&times;</button>

  <div class="policies-main-container">

    <div class="left-nav-container">
      <div class="list-item">
        <p class="list-label" (click)="toggleSubList()">
          Privacy Policy
          <span class="arrow" [class.open]="subListOpen">&#9662;</span>
        </p>

        <div class="sub-list-container" [class.hidden]="!subListOpen">
          <div class="sub-list-item" *ngFor="let item of navItems">
            <p class="nav-list-item" (click)="scrollToSection(item.id)">
              {{item.index}}. {{item.title}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-main-container" id="contentMainContainer">
      <div class="p-3">
        <div class="d-flex justify-content-end">
          <div>
            <p class="page-text"><span class="text-bold">Effective Date: </span>01.12.2024</p>
            <p class="page-text"><span class="text-bold">Last Updated: </span>04.01.2025</p>
          </div>
        </div>

        <h2 class="section-title" id="modalTitle">Privacy Policy</h2>

        <p class="page-text mb-2">
          At <span class="text-bold">TripMeld</span>, a product of
          <span class="text-bold">Reymould Technology Solutions Private Limited</span>
          ("Reymould," "we," "our," or "us"), we are deeply committed to protecting your privacy.
          This Privacy Policy outlines the types of information we collect, how we use and safeguard it, and the rights you have concerning your data.
          By using TripMeld, you agree to the terms of this Privacy Policy.
          If you do not agree to this policy, you must refrain from using TripMeld.
        </p>

        <!-- Each section content -->
        <section *ngFor="let section of navItems" [attr.id]="section.id" class="section-container">
          <h3 class="section-sub-title">{{section.index}}. {{section.title}}</h3>
          <div [innerHTML]="section.content"></div>
        </section>

      </div>
    </div>

  </div>
</div>
